import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { useGetLanguageList } from "../../../services/queries"
import CustomDropdown from "../Form/Dropdown"

const Language = ({
    changeHandler,
    globalLanguageChange,
    renderKey
}) => {
    const { t } = useTranslation()
 
    const { data: languagesData } = useGetLanguageList()
    
    useEffect(() => {
        if (languagesData && languagesData.length) {
            defaultLanguage(languagesData)
        }
    }, [languagesData])

    const defaultLanguage = (languagesData) => {
        const defaultObj = {}
        const isFromCancel = localStorage.getItem("createEditFormCancelClick")
        const languageFieldSet = localStorage.getItem("languageFieldSet")
        const languageFieldSetparse = JSON.parse(languageFieldSet)
        if(isFromCancel && languageFieldSetparse){
            return languageFieldSetparse
        }
        const defaultLan = languagesData.find((language) => {
            return language.is_default
        })
        localStorage.setItem("defaultLanguage_id",  defaultLan?.id)
        if(defaultLan){
            defaultObj.value = defaultLan.id
            defaultObj.label = defaultLan.name
            return defaultObj
        }
    }

    return (
        <>
            { languagesData?.length && 
                <CustomDropdown
                    placeholder={ t("common.selectLanguage") }
                    defaultValue={ globalLanguageChange ? globalLanguageChange : 
                        languagesData?.length && defaultLanguage(languagesData).value  }
                    options={ languagesData?.length ? languagesData.map(({ id, name, code }) => {
                        return { value: id, label: `${code} - ${name}` }
                    }).sort((a,b) => {
                        if (a.label === b.label) {
                            return 0
                        }
                        return a.label > b.label ? 1 : -1
                    }) : [] }
                    name="selectLanguage"
                    changeHandler={ changeHandler }
                    errorData={ [] }
                    isRequired={ false }
                    isMulti={ false }
                    disabled={ false } 
                    renderKey={ renderKey }
                /> }
        </>
    )
}
export default Language
